import CustomerFormHelpText from '../../../ui-components/customer-form/help-text';
import useBookingShop from '../server-data/use-booking-shop';

const CustomerFormHelpTextWithData = () => {
  const { data: shop } = useBookingShop();

  const customerFormHeading = shop?.bookingLocalizations?.customerFormHeading;
  const customerFormText = shop?.bookingLocalizations?.customerFormText;

  return (
    <CustomerFormHelpText
      customerFormHeading={customerFormHeading}
      customerFormText={customerFormText}
    />
  );
};

export default CustomerFormHelpTextWithData;
